.option {
  display: flex;
  align-items: stretch;
  gap: 12px;
  padding: 6px 0;
}

.swatch {
  width: 14px;
  flex: 0 0 auto;
  border: 1.5px solid var(--ink);
  border-radius: 3px;
  background: var(--swatch);
}

.text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.name {
  font-weight: 700;
}

.anchor {
  font-size: 13px;
  font-weight: 400;
  color: var(--ink-2);
}
